import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHamburgerinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		stroke: "currentColor",
		strokeWidth: 2,
		children: /* @__PURE__ */ _jsx("path", { d: "M4 4h16M4 12h16M4 20h16" })
	})
});
export default SvgHamburgerinline;
